
<div class="modal-header" *ngIf="Modale">
  <h5 class="modal-title" id="editUserLabel" style="font-weight: bold"></h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="d-md-flex align-items-center bg-white p-2" *ngIf="HasHeader">
  <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Totale Prodotti:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
  </span>
  <div class="ml-auto mt-3 mt-md-0" >
    <button type="button" class="btn btn-warning rounded-pill py-2" *ngIf="HasEliminatiButton" (click)='showDeleted()'><i
      class="fas fa-ban font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{showAllText}}</span>
    </button>


    <!-- Add Contact -->
    <button type="button" (click)="add()" *ngIf="HasAddButton && (permission.isPermitted('gestione-prodotti') || permission.isPermitted('gestione-sconto'))" class="btn btn-cyan rounded-pill p-2" ><i
        class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
    <button type="button" (click)="toggleOrdinamentoProdoti = !toggleOrdinamentoProdoti" *ngIf="environment.ProdottiAddOn['toggleOrdinamentoProdoti'] && (permission.isPermitted('gestione-prodotti') || permission.isPermitted('gestione-sconto'))" class="btn btn-cyan rounded-pill p-2" >
      <span class="ml-1 text-white font-weight-bold">{{toggleOrdinamentoProdoti ? 'Disabilita ordinamento' : 'Abilita ordinamento'}}</span>
    </button>
    <button type="button" (click)="ImportaSconti()" *ngIf=" id_tipo == '50' && (permission.isPermitted('gestione-prodotti') || permission.isPermitted('gestione-sconto'))" class="btn btn-orange rounded-pill p-2" ><i
      class="fas fa-upload  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Importa Coupon</span>
    </button>
    <ng-container *ngIf="environment?.ProdottiAddOn['dynamicImport'] && permission.isPermitted('gestione-prodotti')" >
      <button *ngFor="let imp of environment?.ProdottiAddOn['dynamicImport']" type="button" (click)="ImportaDynamic(imp)"  class="btn btn-orange rounded-pill p-2" >
        <i class="fas fa-upload  font-14 mr-1 text-white"></i>
        <span class="ml-1 text-white font-weight-bold">{{ imp.label }}</span>
      </button>
    </ng-container>

    <button type="button" (click)="DownloadReport()" *ngIf=" id_tipo == '50' && environment.ProdottiAddOn['report'] && (permission.isPermitted('gestione-prodotti') || permission.isPermitted('gestione-sconto'))" class="btn btn-orange rounded-pill p-2" ><i
      class="fas fa-download  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Scarica Report</span>
    </button>
    <button type="button" (click)="DownloadReport()" *ngIf=" id_tipo == '68' && environment.ProdottiAddOn['report'] &&  (permission.isPermitted('gestione-prodotti') || permission.isPermitted('gestione-sconto'))" class="btn btn-orange rounded-pill p-2" ><i
      class="fas fa-download  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Scarica Report</span>
    </button>
    <button type="button" (click)="Importa()" *ngIf=" id_tipo == '69' && environment.ProdottiAddOn['import'] && (permission.isPermitted('gestione-prodotti'))" class="btn btn-orange rounded-pill p-2" ><i
      class="fas fa-upload  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Importa</span>
    </button>

  </div>
</div>
<div class="d-md-flex align-items-center border-top bg-white p-3" *ngIf="HasFilter && !environment.ProdottiAddOn['prodottiFilter']">

  <form [formGroup]="ricercaform" class="input-group">
    <div class="input-group col-md-9 ">
      <div class="input-group-prepend">
        <label class="input-group-text" for="cerca">Cerca</label>
      </div>
      <input formControlName="cerca" type="text" name="cerca" class="form-control" (keydown)="Search()">
    </div>
    <div class="input-group col-md-3">
      <div class="input-group-prepend ">
        <label class="input-group-text" for="fine">Elementi</label>
      </div>
      <select class="custom-select" (change)="sizeChanged()" formControlName="size">
        <option value="1">1</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option selected value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="500">500</option>
        <option value="1000">1000</option>
      </select>
    </div>
  </form>
</div>
<div class="d-md-flex align-items-center border-top bg-white p-3" *ngIf="HasFilter && environment.ProdottiAddOn['prodottiFilter']">
  <div class="row">

    <div class="input-group col-md-9 " [ngStyle]="{'min-height': filtro.inputType != 'singleDropdown' && filtro.inputType != 'multiselectDropdown' ? 'none' : '48px' }" *ngFor="let filtro of environment.ProdottiAddOn['prodottiFilter']">
      <ng-container *ngIf="(!filtro.filtertype || filtro.filtertype == id_tipo) && showfilter(filtro)">
        <div  class="input-group-prepend" *ngIf="filtro.inputType != 'hidden' && filtro.type != 'hidden'">
          <label class="input-group-text"  for="cerca">{{filtro?.nome}}</label>
        </div>
        <ng-container *ngFor="let oggetto of filtro?.oggetti; let i = index" >
              <ng-template [ngIf]="filtro.type!= 'object' && filtro.inputType == 'date' && filtri[oggetto]">
                <input [(ngModel)]="filtri[oggetto]" [type]="filtro.inputType" name="cerca" class="form-control" (keydown)="onSearchInputChange()">
              </ng-template>
              <ng-template [ngIf]="filtro.type == 'object' && filtro.inputType == 'date'">
                <input [(ngModel)]="filtri[oggetto][filtro.field[i]]" [type]="filtro.inputType" name="cerca" class="form-control" (keydown)="onSearchInputChange()">
              </ng-template>
               <ng-template [ngIf]="filtro.type!= 'object' && filtro.inputType != 'date' && filtro.type != 'replace' && filtro.type != 'objArray' && filtro.inputType != 'multiselectDropdown' && filtro.inputType != 'singleDropdown' && filtro.inputType != 'hidden' && filtro.type != 'hidden'"  >
                 <input [(ngModel)]="filtri[oggetto]" [type]="filtro.inputType ?? 'text'" name="cerca" class="form-control" (keydown)="onSearchInputChange()">
              </ng-template>
              <ng-template [ngIf]="filtro.type == 'object' && filtro.inputType != 'date' && filtro[oggetto]">
                <input [(ngModel)]="filtri[oggetto][filtro.field[i]]" [type]="filtro.inputType ?? 'text'" name="cerca" class="form-control" (keydown)="onSearchInputChange()">
              </ng-template>
          <ng-template
            [ngIf]="filtro.type != 'object' && (filtro.inputType == 'singleDropdown' || filtro.inputType == 'multiselectDropdown')">

            <app-field-viewer [(Oggetto)]="filtri" [hideLabel]="true" [Campi]="getCampoAggiuntivoArray(filtro)" (OnChange)="onSearchInputChange()"></app-field-viewer>

          </ng-template>
           </ng-container>
      </ng-container>
  </div>
</div>
</div>


<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap" cdkDropList [cdkDropListDisabled]="!environment.ProdottiAddOn.DragSort || (!toggleOrdinamentoProdoti && environment.ProdottiAddOn['toggleOrdinamentoProdoti'])" (cdkDropListDropped)="drop($event)">
    <thead>
    <tr *ngIf="environment.ProdottiAddOn['ProdottiListHeader']?.length > 0">
      <ng-container *ngFor="let campo of environment.ProdottiAddOn['ProdottiListHeader']">
        <th scope="col" *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles) && (!campo.filtertype || !id_tipo || id_tipo == campo.filtertype)" >{{campo.nome}}</th>
      </ng-container>
      <th scope="col">Azioni</th>
    </tr>
      <tr *ngIf="!(environment.ProdottiAddOn['ProdottiListHeader']?.length > 0)">
        <th >Prodotto</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn.standby">StandBy</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn.codAdhoc">Codice AdHoc</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn.codice">Codice</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn['keyaccount'] && this.permission.isOperativeRole('K')">Ordinati</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn['keyaccount'] && this.permission.isOperativeRole('K')">Venduti</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn['magazzino']">Magazzino</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn['scortaMinima']">Scorta Minima</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn['updated_at']">Ultima modifica</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn.codice_produttore">Codice Produttore</th>
        <th scope="col" *ngIf="environment.ProdottiAddOn.lista_prezzo">Prezzo</th>
        <th scope="col" *ngIf="permission.isPermitted('gestione-prodotti') && Editable">Azioni</th>
      </tr>
    </thead>
    <tbody *ngIf="!(environment.ProdottiAddOn['ProdottiListHeader']?.length > 0)">
      <tr *ngFor="let co of Prodotti | slice: (HasPaginazione? (page-1) * pageSize : 0) : (HasPaginazione? (page-1) * pageSize + pageSize : Prodotti?.length)" cdkDrag="{{environment.ProdottiAddOn.DragSort}}">
        <td (click)='edit(co)'>
          <span class="text-dark font-medium font-16">
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="info" class="feather-sm"></i-feather>
            </span>
            {{ co.prodotto}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn.standby">
          <span [class.text-danger]="co.standby" [class.text-success] = "!co.standby" >
            <i class=" far fa-times-circle" [class.far] ="co.standby" [class.fa-times-circle] ="co.standby" [class.fas] ="!co.standby" [class.fa-check-circle] ="!co.standby" ></i>
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn.codAdhoc">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.codiceAdhoc}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn.codice">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.codice}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn['keyaccount'] && this.permission.isOperativeRole('K')">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.ordinati}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn['keyaccount'] && this.permission.isOperativeRole('K')">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.venduti}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn['magazzino']">
          <span>

            {{ co.magazzino }}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn['scortaMinima']">
          <span>

            {{ co.scortaMinima}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)' *ngIf="environment.ProdottiAddOn['updated_at']">
          <span>
            <i class="fas fa-calendar"></i> &nbsp;
            {{ co.updated_at | date: 'dd/MM/yyyy HH:mm'}}
          </span>
        </td>
        <td class="align-middle " (click)='edit(co)' *ngIf="environment.ProdottiAddOn.codice_produttore">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.codice_produttore}}
          </span>
        </td>
        <td class="align-middle " (click)='edit(co)' *ngIf="environment.ProdottiAddOn.lista_prezzo">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-euro-sign"></i>
            </span>
            {{ getprice(co)}}
          </span>
        </td>
        <td class="align-middle" *ngIf="permission.isPermitted('gestione-prodotti') && Editable">
          <a *ngIf="HasEditButton" href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='edit(co)'>
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a *ngIf="HasEditButton" href="javascript:void(0)" ngbTooltip="Duplica" class="link font-16 text-info font-medium mr-2" (click)='Copy(co)'>
            <i class="fas fa-copy"></i>
          </a>
          <a *ngIf="environment.ProdottiAddOn.standby" href="javascript:void(0)" ngbTooltip="Standby" class="link font-16 text-info font-medium mr-2" (click)='ReverseStandby(co)'>
            <i class="fas fa-sync"></i>
          </a>

<!--          <a *ngIf="HasEditButton && environment.ProdottiAddOn.TranslatedDesc" href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='translations(co)'>-->
<!--            <i class="far fa-flag"></i>-->
<!--          </a>-->
<!--          <a *ngIf="HasOpenButton" href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='Open(co)'>-->
<!--            <i class="fas fa-eye"></i>-->
<!--          </a>-->
          <a *ngIf="(co.enabled || !HasRestoreButton) && HasDeleteButton"  href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='delete(co)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="!co.enabled && HasRestoreButton" href="javascript:void(0)" class="link text-orange font-16 font-weight-bold" (click)='renew(co)'>
            <i-feather name="plus" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="environment.ProdottiAddOn['ProdottiListHeader']?.length > 0">
    <tr *ngFor="let item of Prodotti | slice: (HasPaginazione? (page-1) * pageSize : 0) : (HasPaginazione? (page-1) * pageSize + pageSize : Prodotti?.length) " cdkDrag="{{environment.ProdottiAddOn.DragSort}}">
      <ng-container *ngFor="let campo of environment.ProdottiAddOn['ProdottiListHeader']">
        <td *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles) && (!campo.filtertype || !id_tipo || id_tipo == campo.filtertype)" (click)='ListClick(item, campo)'>
          <span style="font-size: 14px;" *ngIf="!campo.modificabile" [ngClass]="{'badge badge-pill px-3': campoUtility.Colore(campo,item) }" [ngStyle]="{'color': campoUtility.Colore(campo,item)?  LightenColor(campoUtility.Colore(campo,item)) : '', 'background-color': campoUtility.Colore(campo,item)}">
            <ng-container *ngFor="let oggetto of campo.oggetti; let i = index" >
              <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'date' && item[oggetto]">
                {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy'}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type == 'object' && campo.inputType == 'date'">
                {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy'}} &nbsp;
              </ng-template>
               <ng-template [ngIf]="campo.type!= 'object' && campo.inputType != 'date' && campo.type != 'replace' && campo.type != 'objArray'">
                {{campoUtility.getObj(item, oggetto)}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type == 'object' && campo.inputType != 'date' && item[oggetto]">
                {{campoUtility.getObj(item, oggetto)[campo.field[i]]}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type == 'object' && campo.inputType != 'date' && !item[oggetto] && campo.oggettisec && campo.oggettisec[i] && item[campo.oggettisec[i]]">
                {{item[campo.oggettisec[i]][campo.field[i]]}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type == 'replace' ">
                {{campoUtility.Replace(campo,item, oggetto)}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type == 'objArray' ">
                <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
                  {{obg[campo.field[i]]}} &nbsp;
                </ng-container>
              </ng-template>

           </ng-container>
          </span>
          <app-field-viewer *ngIf="campo.modificabile" [hideLabel]="true" [(Oggetto)]="Prodotti[productIndex(item)]" [Campi]="[campo]"></app-field-viewer>
        </td>
      </ng-container>
      <td class="align-middle" *ngIf="permission.isPermitted('gestione-prodotti') && Editable">
        <ng-container *ngIf="environment.ProdottiAddOn['AzioniLista']">
          <ng-container *ngFor="let button of environment.ProdottiAddOn['AzioniLista']">
            <a *ngIf="permission.HasCapacity(button['capacita']) && campoUtility.ButtonShow(button,item) && (!button.filtertype || !id_tipo || id_tipo == button.filtertype)" (click)='customButton(button, item)' [ngClass]="button['class']" href="javascript:void(0)"  >
              {{button.iconText ?? ''}}<i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
            </a>
          </ng-container>
        </ng-container>
        <a *ngIf="HasEditButton" href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='edit(item)'>
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a *ngIf="HasEditButton" href="javascript:void(0)" ngbTooltip="Duplica" class="link font-16 text-info font-medium mr-2" (click)='Copy(item)'>
          <i class="fas fa-copy"></i>
        </a>
        <a *ngIf="environment.ProdottiAddOn.standby && !Modale" href="javascript:void(0)" ngbTooltip="Standby" class="link font-16 text-info font-medium mr-2" (click)='ReverseStandby(item)'>
          <i class="fas fa-sync"></i>
        </a>
        <a *ngIf="(item.enabled || !HasRestoreButton) && HasDeleteButton"  href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='delete(item)'>
          <i-feather name="trash-2" class="feather-sm"></i-feather>
        </a>
        <a *ngIf="!item.enabled && HasRestoreButton" href="javascript:void(0)" class="link text-orange font-16 font-weight-bold" (click)='renew(item)'>
          <i-feather name="plus" class="feather-sm"></i-feather>
        </a>
        <a *ngIf="Modale" href="javascript:void(0)" class="link text-orange font-16 font-weight-bold" (click)='Add(item)'>
          <i-feather name="plus" class="feather-sm"></i-feather>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top" *ngIf="HasPaginazione">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
